module.exports = __webpack_public_path__ + "static/media/excel_bar.e343006e.png";